import styled from 'styled-components';
import { font } from 'styles/globals';
import { getColor, Theme } from 'styles/theme';

export const VideoWrapper = styled.div`
  margin: 0 0 8px;
  position: relative;
  img {
    transition: 0.35s ease-in-out;
    aspect-ratio: 16/9;
    
    &:hover {
      transition: 0.35s ease-in-out;
      filter: brightness(80%);
    }
  }
`;

export const PlayButton = styled.div<{ theme: Theme }>`
  color: ${getColor('neutralWhite')};
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  text-align: center;
  top: 50%;
  transform: translateY(-50%);

  > svg {
    height: 36px;
    width: 36px;
  }

  > svg:hover {
    animation: ease-out 1s;
    height: 40px;
    width: 40px;
  }
`;

export const TimerWrapper = styled.div`
  align-items: center;
  background-color: ${`${getColor('surfaceTertiary')}CC`};
  bottom: 0;
  display: flex;
  height: 24px;
  justify-content: center;
  position: absolute;
  right: 0;
  width: 61px;
`;

export const Timer = styled.span<{ theme: Theme }>`
  color: ${getColor('neutralWhite')};
  font-family: ${font.graphikCond};
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0.53px;
  line-height: 19px;
`;
